'use client';

import { ReferenceItem } from '@/app/services/llm';
import { ReferencePreviewPanel } from '@/components/reference-preview-panel';
import { type AbstractLocale } from '@/components/search/abstract-preview-content';
import { getReferenceDetailUrl } from '@/lib/reference-detail-url';
import { useState } from 'react';

type DeepResearchPreviewProps = {
  current: ReferenceItem;
  onClose: () => void;
  canGoBack?: boolean;
  onBack?: () => void;
  referenceIndex?: number;
};

export function DeepResearchPreview({
  current,
  onClose,
  canGoBack,
  onBack,
  referenceIndex,
}: DeepResearchPreviewProps) {
  const [selectedTab, setSelectedTab] = useState<AbstractLocale>('zh');

  return (
    <ReferencePreviewPanel
      current={{
        ...current,
        publication: current.publisher,
      }}
      locale={selectedTab}
      onLocaleChange={setSelectedTab}
      onClose={onClose}
      canGoBack={canGoBack}
      onBack={onBack}
      referenceIndex={referenceIndex}
      detailHref={getReferenceDetailUrl(current)}
    />
  );
}
